/**
 * Returns the complete users management state
 *
 * @param {object} state - Current state
 * @returns {object} - The entire banner notification state
 */
function getUsersManagementState(state) {
  const toRet = {
    ...state.usersManagement,
  };
  return toRet;
}

export default getUsersManagementState;
